/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Colleagues_DescInputs */



/**
* | output |
* | --- |
* | "Wundo prepares and follows up your one-to-ones with these colleagues." |
*
* @param {Meetings_Colleagues_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_colleagues_desc = /** @type {((inputs?: Meetings_Colleagues_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Colleagues_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo bereidt je one-to-ones met deze collega's voor en volgt ze op.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo prépare et suit vos one-to-ones avec ces collègues.")
	return /** @type {LocalizedString} */ ("Wundo prepares and follows up your one-to-ones with these colleagues.")
});